export const format = (val: string) => `$` + val
export const parse = (val: string) => val.replace(/^\$/, '')

type GoalSeekOptions = {
  tolerance?: number
  maxIterations?: number
  min?: number
  max?: number
}

export function goalSeek(
  fn: (x: number) => number,
  goal: number,
  options: GoalSeekOptions = {}
): number {
  const tolerance = options.tolerance ?? 0.000001
  const maxIterations = options.maxIterations ?? 100
  let low = options.min ?? -1_000_000
  let high = options.max ?? 1_000_000

  let mid = 0

  for (let i = 0; i < maxIterations; i++) {
    mid = (low + high) / 2
    const value = fn(mid)

    if (Math.abs(value - goal) < tolerance) {
      return mid
    }

    if (value > goal) {
      high = mid
    } else {
      low = mid
    }
  }

  return mid
}